import moment from 'moment'
import _ from 'lodash'
import timesheetsAPI from '../api/timesheets'

export default {
  weekDays (from, to) {
    /*  Builds an array of date strings in the form: YYYY-MM-DD
        starting at the `from` value and the `to` values passed in.
        Expects strings passed in using the same format of YYYY-MM-DD
    */
    let array = []
    let date = from 
    array.push(date)
    if (!moment(from).isSameOrAfter(to)) {
      while (date !== to) {
        date = moment(date).add(1, 'days').format('YYYY-MM-DD').toString()
        array.push(date)
      }
    }
    return array
  },
  async updateEntryHoursLeft (entry) {
    /*
      When the user adds or deletes a "workedOn" record, this will change how many hours of detail are left to
      be explained. So we need to update the main entry to reflect this change. This function can be called
      from either the `addLine` function in the `WorkedOnStepper` component, or from the the `deleteLine` function
      found in the `DayEntryLines` component.
    */
    // First gather all the `workedOn` records, to determine how many hours have been "used up" so far
    let tmp = await timesheetsAPI.getTimesheetWorkedOns(entry.id)
    let lineHours = _.sumBy(tmp, function (n) { return parseFloat(n.num_hours) })
    let entryHours = this.hoursWorked(entry)
    return entryHours - lineHours 
  },
  hoursWorked (entry) {
    let hrs = moment(entry.end, 'HH:mm:ss').diff(moment(entry.start, 'HH:mm:ss'), 'minutes')
    hrs = (hrs / 60)
    if (entry.had_lunch) {
      return (hrs - 0.5).toFixed(2)
    } else {
      return hrs.toFixed(2)
    }
  }
}